import * as React from 'react';
import MultiTextEdit from './MultiTextEdit';
import {emotionStyled, tokens} from '@packages/utilities/styled';
import {TypeImplementation} from '@packages/systems/wfdl';

const StyledMultiEditWrapper = emotionStyled('div')({
  marginBottom: tokens.space[2],
});
type State = {
  textStateCopy: Record<any, any>;
  temp: {
    state: string;
  };
};

const MultiTextEditWithCategories = ({
  textStates,
  legacyStatePath,
  categories,
  env,
  state,
  dispatch,
}: {
  state: State;
  dispatch: TypeImplementation.ExpressionEditorDispatch;
  textStates: Record<any, any>;
  legacyStatePath?: Array<string>;
  categories: Record<any, any>;
  env: any;
}) => {
  function filterTextStates(category: any) {
    return Object.keys(textStates).reduce<Record<string, any>>((acc, key) => {
      const textState = textStates[key];
      if (
        !textState.beta ||
        env.isEnabled({type: 'betaFlag', key: textState.beta})
      ) {
        if (category) {
          if (textState.category.id === category) {
            acc[key] = textState;
          }
          return acc;
        }
        acc[key] = textState;
      }
      return acc;
    }, {});
  }
  const categoryKeys = Object.keys(categories);
  const filteredByCategories =
    categoryKeys &&
    categoryKeys.reduce<Record<string, any>>((acc, category) => {
      acc[category] = filterTextStates(category);
      return acc;
    }, {});
  const isEmpty = (obj: any) => Object.keys(obj).length === 0;
  return (
    <div>
      {Object.values(filteredByCategories).map((categorizedStates, idx) => {
        if (isEmpty(categorizedStates)) {
          return;
        }
        const categoryLabelKey = Object.keys(filteredByCategories)[idx];
        // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
        const categoryLabel = categories[categoryLabelKey].label;
        return (
          <StyledMultiEditWrapper key={categoryLabel}>
            <MultiTextEdit
              state={state}
              dispatch={dispatch}
              textStates={textStates}
              categorizedStates={categorizedStates}
              label={categoryLabel}
              legacyStatePath={legacyStatePath}
              // @ts-expect-error - TS2322 - Type '{ state: State; dispatch: (arg1?: any) => void; textStates: Record<any, any>; categorizedStates: any; label: any; legacyStatePath: string[] | undefined; categories: Record<any, any>; }' is not assignable to type 'IntrinsicAttributes & { state: State; dispatch: (arg1?: any) => void; textStates: Record<any, any>; label: string; legacyStatePath?: string[] | undefined; categorizedStates?: Record<...> | undefined; }'.
              categories={categories}
            />
          </StyledMultiEditWrapper>
        );
      })}
    </div>
  );
};

export default MultiTextEditWithCategories;
